import { Box, Flex } from '@chakra-ui/react';
import { BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';
import { IconType } from 'react-icons';
import {
  ActionButton,
  ActionButtonGroup,
  Background,
  ScrollThumb,
  Section,
} from './ScrollbarAtoms';
import { DataDirection } from '../../../../core/types/ui/position';
import useColScrollbar, {
  ColScrollbarProps,
} from '../../../hooks/useColScrollbar';
import { GridEntity } from '../../../types';

const ColScrollbar: React.FC<ColScrollbarProps> = (props) => {
  const {
    gridWidth,
    stroke,
    freezedCols,
    startSingleScroll,
    jumpScrollToStartEnd,
  } = props;

  const {
    scrollBarHeight,
    buttonSize,
    buttonGroupWidth,
    scrollAreaWidth,
    frozenAreaWidth,
    leftSectionWidth,

    scrollThumbWidth,
    thumbPosition,

    thumbRef,
    onThumbMouseDown,
  } = useColScrollbar(props);

  // const scrollBarHeight = SheetDefaults.scrollBarHeight;
  // const buttonSize = scrollBarHeight;
  // const leftSectionWidth = Math.max(props.rowHeaderWidth, buttonSize * 2);
  // const buttonGroupWidth = buttonSize * 2;

  // const freezeBarHandleSize = getFreezeBarHandleSize(freezedCols, props.zoom);

  // const frozenAreaWidth = freezedCols.frozen
  //   ? freezedColsSum + freezeBarHandleSize
  //   : 0;

  const scrollArea = () => {
    // const scrollAreaWidth =
    //   gridWidth - leftSectionWidth - buttonGroupWidth - frozenAreaWidth;
    return (
      <Box
        width={`${scrollAreaWidth}px`}
        position="relative"
        height="100%"
        overflow="hidden"
        as={Flex}
        alignItems="center"
      >
        <ScrollThumb
          background={stroke}
          styleProps={{
            left: `${thumbPosition}px`,
            height: '80%',
            width: `${scrollThumbWidth}px`,
          }}
          thumbRef={thumbRef}
          // hoverStyle={{
          //   height: '85%',
          // }}
          onThumbMouseDown={onThumbMouseDown}
        />
      </Box>
    );
  };

  const frozenAreaView = () => (
    <Box
      width={`${frozenAreaWidth}px`}
      position="relative"
      height="100%"
      background={stroke}
      opacity={0.2}
    />
  );

  const actionButtonView = (
    Icon: IconType,
    direction: DataDirection,
    isSingleJump: boolean
  ) => (
    <ActionButton
      background={stroke}
      buttonProps={{
        height: '100%',
        width: `${buttonSize}px`,
      }}
      onMouseDown={isSingleJump ? startSingleScroll : undefined}
      onClick={!isSingleJump ? jumpScrollToStartEnd : undefined}
      Icon={Icon}
      entityType={GridEntity.Column}
      direction={direction}
    />
  );

  const buttonGroup = (width: number, isSingleJump = false) => {
    const { LeftIcon, RightIcon } = getArrowIcon(isSingleJump, props.isRtl);
    return (
      <Section
        sectionProps={{
          width: `${width}px`,
          height: '100%',
          //   flexDirection: 'row',
          //   alignItems: "flex-end",
          //   display: "flex"
        }}
      >
        <ActionButtonGroup
          stroke={stroke}
          buttonGroupProps={{
            height: '100%',
            width: `${buttonGroupWidth}px`,
            borderWidth: '0px 1px',
          }}
        >
          {actionButtonView(
            // isSingleJump ? RiArrowLeftSLine : BiArrowToLeft,
            LeftIcon,
            DataDirection.Backward,
            isSingleJump
          )}
          {actionButtonView(
            // isSingleJump ? RiArrowRightSLine : BiArrowToRight,
            RightIcon,
            DataDirection.Forward,
            isSingleJump
          )}
        </ActionButtonGroup>
      </Section>
    );
  };

  return (
    <Background
      stroke={stroke}
      boxProps={{
        bottom: `-${scrollBarHeight}`,
        left: '0px',
        height: `${scrollBarHeight}px`,
        width: `${gridWidth}px`,
        borderWidth: '1px 0px',
        // display: "flex"
      }}
    >
      {buttonGroup(leftSectionWidth)}
      {freezedCols.frozen && frozenAreaView()}
      {scrollArea()}
      {buttonGroup(buttonGroupWidth, true)}
    </Background>
  );
};

const getArrowIcon = (isSingleJump: boolean, isRtl: boolean) => {
  const singleIconL = isRtl ? RiArrowRightSLine : RiArrowLeftSLine;
  const singleIconR = isRtl ? RiArrowLeftSLine : RiArrowRightSLine;

  const jumpIconL = isRtl ? BiArrowToRight : BiArrowToLeft;
  const jumpIconR = isRtl ? BiArrowToLeft : BiArrowToRight;

  return {
    LeftIcon: isSingleJump ? singleIconL : jumpIconL,
    RightIcon: isSingleJump ? singleIconR : jumpIconR,
  };
};

export default ColScrollbar;
